export function filterAllCompanies<
  T extends {
    id: string;
    name: string;
    country?: string | null;
    defaultLanguage?: string | null;
  },
>(allCompanies: T[] | null | undefined, superAdminUserType: string | null | undefined): T[] {
  const isBarcontrol = superAdminUserType === 'BARCONTROL';
  const isSpainUser = superAdminUserType === 'SPAIN';

  return isBarcontrol
    ? allCompanies?.filter((c) => (c.country || c.defaultLanguage)?.toUpperCase() === 'NO') ?? []
    : isSpainUser
    ? allCompanies?.filter((c) => (c.country || c.defaultLanguage)?.toUpperCase() === 'ES') ?? []
    : allCompanies ?? [];
}
